import React from 'react'
import { Dialog } from '@material-ui/core'
import { CSVDownloadErrorPopup } from './CSVDownloadErrorPopup'


export const CSVDownloadError = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableBackdropClick
    >
      <CSVDownloadErrorPopup handleClose={onClose} />
    </Dialog>
  )
}
